import { Socket } from "phoenix";
import { LiveSocket } from "phoenix_live_view";
import Chartkick from "chartkick";
import "chartkick/chart.js";

import initDropdown from "./oldSchool/initDropdown";

const csrfToken = document
  .querySelector("meta[name='csrf-token']")
  .getAttribute("content");

const hooks = {
  AutosuggestedField: {
    mounted() {
      this.el.addEventListener("blur", (e) => {
        setTimeout(() => {
          this.pushEventTo(this.el, "blur");
        }, 200);
      });
      this.el.addEventListener("keydown", (e) => {
        switch (e.key) {
          case "ArrowDown":
          case "ArrowUp":
          case "Enter":
            e.preventDefault();
            break;
        }
      });
      this.handleEvent("nio:select", ({ id, value }) => {
        if (id == this.el.id) {
          this.el.value = value;
        }
      });
      this.handleEvent("nio:clear", ({ id }) => {
        if (id == this.el.id) {
          this.el.value = "";
        }
      });
      this.handleEvent("nio:hide-suggestions", () => {
        const sib = this.el.nextElementSibling;
        // This timeout is needed because server rerenders stuff which would make it visible again
        setTimeout(() => {
          if (sib && sib.getAttribute("data-js") === "suggestion-box") {
            sib.classList.add("opacity-0");
            sib.classList.remove("opacity-100");
            setTimeout(() => {
              sib.classList.add("pointer-events-none");
            }, 200);
          }
        }, 200);
      });
      this.handleEvent("nio:show-suggestions", () => {
        const sib = this.el.nextElementSibling;
        if (sib && sib.getAttribute("data-js") === "suggestion-box") {
          sib.classList.add("opacity-100");
          sib.classList.remove("opacity-0");
          sib.classList.remove("pointer-events-none");
        }
      });
    },
  },

  Confirmation: {
    mounted() {
      this.el.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (confirm(this.el.getAttribute("data-confirm-message"))) {
          this.pushEvent(
            this.el.getAttribute("data-confirm-event"),
            this.el.getAttribute("data-confirm-payload")
          );
        }
      });
    },
  },

  DelayedBlur: {
    mounted() {
      this.el.addEventListener("blur", (event) => {
        setTimeout(() => {
          this.pushEvent(this.el.getAttribute("data-blur-event"));
        }, parseInt(this.el.getAttribute("data-blur-delay"), 10) || 200);
      });
    },
  },

  RenderChart: {
    mounted() {
      new Chartkick.LineChart(
        this.el.id,
        JSON.parse(this.el.getAttribute("data-chart-data")),
        enhanceOptions(JSON.parse(this.el.getAttribute("data-chart-options")))
      );
    },
    updated() {
      new Chartkick.LineChart(
        this.el.id,
        JSON.parse(this.el.getAttribute("data-chart-data")),
        enhanceOptions(JSON.parse(this.el.getAttribute("data-chart-options")))
      );
    },
  },

  Dropdown: {
    mounted() {
      initDropdown(this.el);
    },
  },
};

function enhanceOptions(data) {
  return {
    ...data,
    options: {
      ...data.options,
      labels: ["one", "two"],
      scales: {
        ...data.options.scales,
        x: {
          ...data.options.scales.x,
          tick: {
            callback: function (value, _index, _ticks) {
              return value;
            },
          },
        },
      },
    },
  };
}

const liveSocket = new LiveSocket("/live", Socket, {
  params: { _csrf_token: csrfToken },
  hooks,
});
liveSocket.connect();

export default liveSocket;
